<template>
    <div class="d-none col-md-2 d-md-flex flex-column align-self-center align-self-md-start mx-auto">
      <div class="col-12 text-center">Question</div>

      <div class="col-12 d-flex align-self-center justify-content-between">

        <span class="h4">{{ currentQuestionNumber }} <small>of</small> {{ numberOfQuestionsInSection }}</span>

      </div>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'enquiry-form-question-progress',
  props: {
    currentQuestionNumber: {},
    currentSection: {}
  },

  computed: {
    ...mapGetters({
      questions: 'form/questions',
      answers: 'form/answers',
      sections: 'form/sections'
    }),

    numberOfQuestionsInSection: function () {
      return this.questions.filter(question => {
        return question.question_section_id === this.currentSection
      }).length
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/enquiry-form-question-progress.vue